export const faqData = [
  {
    id: 'faq-1',
    question: '51电影网的未删减版和普通版本有什么区别？',
    answer: '普通版本因审查或市场分级需求，常对敏感镜头、限制级片段进行删减或遮挡处理。51电影网整理的是未删减完整版资源，保留了导演原始创作中的隐藏镜头与完整叙事，让你看到被剪切背后的真实内容。',
  },
  {
    id: 'faq-2',
    question: '网站上的资源更新频率是怎样的？',
    answer: '我们保持每周至少一次的更新节奏，涵盖新发现的未删减版片源、经典电影的导演剪辑版以及热门擦边电影的高清修复版本。遇到特殊专题时还会增加更新频次。',
  },
  {
    id: 'faq-3',
    question: '所有电影都支持高清在线观看吗？',
    answer: '是的，站内所有完整版资源均提供高清画质在线观看。我们优先收录蓝光修复和1080P以上清晰度的版本，确保观影体验不打折。部分稀缺资源最低也保证720P可看标准。',
  },
  {
    id: 'faq-4',
    question: '如何找到特定类型的限制级或隐藏资源？',
    answer: '你可以通过首页的话题标签、专题合集以及热度榜单快速定位感兴趣的内容。每个专题都按主题类型精心分类，点击即可直达对应资源列表，方便快捷。',
  },
  {
    id: 'faq-5',
    question: '51电影网的资源来源可靠吗？是否安全？',
    answer: '我们所有资源均来自公开渠道整理与用户贡献，站内仅提供内容索引与观看引导。我们严格遵守相关法律法规，并持续优化内容筛选机制，保障访问安全与内容质量。',
  },
];

export const topicsData = [
  { id: 't-1', name: '未删减版', heat: '4.2k', icon: 'ri-film-line' },
  { id: 't-2', name: '限制级片段', heat: '3.8k', icon: 'ri-forbid-2-line' },
  { id: 't-3', name: '隐藏镜头', heat: '3.1k', icon: 'ri-eye-off-line' },
  { id: 't-4', name: '导演剪辑版', heat: '2.9k', icon: 'ri-knife-line' },
  { id: 't-5', name: '敏感内容', heat: '2.6k', icon: 'ri-alert-line' },
  { id: 't-6', name: '海外完整版', heat: '2.4k', icon: 'ri-global-line' },
  { id: 't-7', name: '禁片档案', heat: '2.1k', icon: 'ri-lock-line' },
  { id: 't-8', name: '高清修复', heat: '1.9k', icon: 'ri-hd-line' },
  { id: 't-9', name: '独家片源', heat: '1.7k', icon: 'ri-vip-crown-line' },
];

export const indexData = [
  {
    id: 'idx-1',
    title: '本月热门未删减',
    desc: '当月最受关注的擦边电影完整版合集，热度持续攀升中',
    count: 42,
    icon: 'ri-fire-line',
  },
  {
    id: 'idx-2',
    title: '经典限制级回顾',
    desc: '影史经典中那些被删减的限制级片段，一次完整呈现',
    count: 28,
    icon: 'ri-history-line',
  },
  {
    id: 'idx-3',
    title: '新片速递',
    desc: '最新上线的未分级版与海外完整版资源，抢先一步观看',
    count: 15,
    icon: 'ri-rocket-line',
  },
  {
    id: 'idx-4',
    title: '冷门隐藏佳作',
    desc: '小众但口碑极佳的限制级电影，隐藏的宝藏等你发掘',
    count: 36,
    icon: 'ri-treasure-map-line',
  },
  {
    id: 'idx-5',
    title: '导演未删减专题',
    desc: '按导演整理其作品中被删减的敏感镜头与原始版本',
    count: 19,
    icon: 'ri-user-star-line',
  },
  {
    id: 'idx-6',
    title: '类型精选',
    desc: '按惊悚、文艺、悬疑等类型分类的限制级电影高清合集',
    count: 53,
    icon: 'ri-stack-line',
  },
  {
    id: 'idx-7',
    title: '年度完整版盘点',
    desc: '全年最值得关注的未删减版电影大盘点，一篇看尽精华',
    count: 24,
    icon: 'ri-trophy-line',
  },
];

export const rankingData = [
  { rank: 1, title: '《欲望迷宫》未删减版', heat: '9.8', tag: '限制级', desc: '导演剪辑完整版首次流出，隐藏镜头逐一揭晓' },
  { rank: 2, title: '《暗夜追踪》海外版', heat: '9.5', tag: '高清修复', desc: '海外发行完整版，敏感片段全部保留' },
  { rank: 3, title: '《禁忌游戏》蓝光修复', heat: '9.2', tag: '未分级', desc: '蓝光高清修复，原版限制级镜头完整呈现' },
  { rank: 4, title: '《午夜迷情》加长版', heat: '8.9', tag: '独家片源', desc: '加长版比院线多出23分钟敏感内容' },
  { rank: 5, title: '《深渊之眼》完整版', heat: '8.6', tag: '隐藏资源', desc: '被删减的黑暗结局首次公开，全网独家' },
];

export const updatesData = [
  { id: 'up-1', date: '2026-07-29', title: '《欲望迷宫》导演剪辑版上线，新增17分钟限制级内容', tag: '新片上线' },
  { id: 'up-2', date: '2026-07-27', title: '经典禁片《堕落天使》蓝光高清修复版完整发布', tag: '高清修复' },
  { id: 'up-3', date: '2026-07-25', title: '本周「海外完整版」专题更新，新增8部未删减资源', tag: '专题更新' },
  { id: 'up-4', date: '2026-07-22', title: '《暗夜追踪》海外版敏感镜头对比解析已整理上线', tag: '深度解析' },
  { id: 'up-5', date: '2026-07-20', title: '七月热度榜单刷新，《禁忌游戏》蓝光版登顶榜首', tag: '榜单更新' },
  { id: 'up-6', date: '2026-07-18', title: '冷门佳作专题新收录5部小众限制级高分电影', tag: '冷门推荐' },
  { id: 'up-7', date: '2026-07-15', title: '《午夜迷情》加长版独家片源上线，完整版首次公开', tag: '独家首发' },
  { id: 'up-8', date: '2026-07-12', title: '暑期观影季启动，每周双更未删减版资源合集', tag: '活动通知' },
];

export const featuresData = [
  {
    id: 'feat-1',
    title: '独家完整资源',
    desc: '持续追踪全球擦边电影未删减版动态，整理限制级片段与隐藏镜头，提供全网独家的高清完整版在线观看入口。每一部资源都经过严格筛选和版本比对。',
    icon: 'ri-vip-diamond-line',
  },
  {
    id: 'feat-2',
    title: '高清画质保障',
    desc: '所有未分级电影与完整版资源均以蓝光修复或1080P以上清晰度收录，拒绝模糊画质。敏感镜头的每一帧细节都清晰可辨，还原导演创作本意。',
    icon: 'ri-4k-line',
  },
  {
    id: 'feat-3',
    title: '每周准时更新',
    desc: '固定每周更新稀缺资源，涵盖新片速递、禁片档案、海外完整版等多个维度。无论你是寻找经典回顾还是最新发现，都能在这里找到持续更新的隐藏内容。',
    icon: 'ri-calendar-check-line',
  },
];

export const cardsData = [
  {
    id: 'card-1',
    title: '《欲望迷宫》未删减版',
    desc: '导演剪辑版完整流出，17分钟被删限制级镜头全部还原，悬疑氛围层层递进',
    tag: '新片首发',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20dark%20atmospheric%20movie%20poster%20with%20intense%20red%20and%20shadow%20contrast%2C%20mysterious%20figure%20silhouette%2C%20film%20noir%20aesthetic%2C%20dramatic%20lighting%2C%20dark%20amber%20tones%2C%20cinematic%20composition%2C%20high%20contrast%2C%20editorial%20film%20poster%20style&width=600&height=800&seq=card-2026-maze&orientation=portrait',
  },
  {
    id: 'card-2',
    title: '《暗夜追踪》海外完整版',
    desc: '海外发行版本敏感镜头全保留，动作场面完整无删减，画质蓝光级修复',
    tag: '高清修复',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20action%20thriller%20movie%20poster%20with%20urban%20night%20cityscape%20background%2C%20neon%20accents%2C%20mysterious%20atmosphere%2C%20cinematic%20lighting%20with%20deep%20shadows%2C%20film%20poster%20composition%2C%20dark%20crimson%20and%20black%20color%20palette&width=600&height=800&seq=card-2026-night&orientation=portrait',
  },
  {
    id: 'card-3',
    title: '《禁忌游戏》蓝光修复',
    desc: '高分限制级电影蓝光修复版，原版镜头完整呈现，画面质感全面升级',
    tag: '蓝光修复',
    imageUrl: 'https://readdy.ai/api/search-image?query=Psychological%20thriller%20movie%20poster%20style%20with%20chess%20pieces%20and%20shadow%20play%2C%20dark%20elegant%20aesthetic%2C%20gold%20accents%20on%20deep%20black%20background%2C%20cinematic%20composition%2C%20sophisticated%20film%20poster%20art%2C%20dramatic%20chiaroscuro%20lighting&width=600&height=800&seq=card-2026-forbidden&orientation=portrait',
  },
  {
    id: 'card-4',
    title: '《午夜迷情》加长版',
    desc: '比院线多出23分钟的完整体验，隐藏结局和敏感对话首次揭开面纱',
    tag: '独家片源',
    imageUrl: 'https://readdy.ai/api/search-image?query=Romantic%20noir%20movie%20poster%20with%20midnight%20blue%20and%20deep%20red%20tones%2C%20couple%20silhouette%20against%20city%20lights%2C%20atmospheric%20fog%2C%20cinematic%20composition%2C%20film%20poster%20aesthetic%2C%20soft%20dramatic%20lighting&width=600&height=800&seq=card-2026-midnight&orientation=portrait',
  },
  {
    id: 'card-5',
    title: '《深渊之眼》完整版',
    desc: '被删减黑暗结局首次公开，全网独家资源，未分级版本含敏感心理描写',
    tag: '隐藏资源',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20psychological%20horror%20movie%20poster%20with%20single%20eye%20motif%2C%20deep%20black%20and%20crimson%20color%20scheme%2C%20abstract%20geometric%20shapes%2C%20cinematic%20composition%2C%20disturbing%20elegant%20aesthetic%2C%20film%20poster%20style%20with%20strong%20contrast&width=600&height=800&seq=card-2026-abyss&orientation=portrait',
  },
  {
    id: 'card-6',
    title: '《堕落天使》禁片修复',
    desc: '影史经典禁片高清修复完整版，原版限制级片段与隐藏镜头逐一还原呈现',
    tag: '经典修复',
    imageUrl: 'https://readdy.ai/api/search-image?query=Classic%20arthouse%20film%20poster%20with%20angel%20wing%20silhouette%20in%20darkness%2C%20black%20and%20crimson%20contrast%2C%20vintage%20cinematic%20aesthetic%2C%20grainy%20texture%2C%20dramatic%20chiaroscuro%20lighting%2C%20film%20poster%20composition%20with%20minimalist%20design&width=600&height=800&seq=card-2026-fallen&orientation=portrait',
  },
];

export const carouselData = [
  {
    id: 'car-1',
    title: '暑期观影季：未删减版特辑',
    subtitle: '每周双更 · 限时专题',
    desc: '这个夏天，51电影网为你精心准备了暑期观影特辑。从经典禁片档案到最新海外完整版，从未分级限制级到隐藏镜头揭秘——我们以每周双更的节奏，持续为你奉上最值得关注的擦边电影未删减版资源。每部影片都附带删减对比解析，带你发现银幕背后的秘密。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20wide%20banner%20with%20warm%20summer%20night%20atmosphere%2C%20film%20projector%20beam%20cutting%20through%20darkness%2C%20deep%20crimson%20and%20gold%20accents%2C%20movie%20theater%20nostalgia%2C%20wide%20cinematic%20composition%2C%20rich%20dark%20textures%2C%20elegant%20film%20festival%20aesthetic&width=960&height=540&seq=car-2026-summer&orientation=landscape',
  },
  {
    id: 'car-2',
    title: '禁片档案：被隐藏的影史经典',
    subtitle: '深度挖掘 · 完整还原',
    desc: '有些电影因为题材敏感或画面大胆，在部分地区被删减甚至禁映。51电影网「禁片档案」专题致力于挖掘这些被隐藏的影史经典，以蓝光高清修复标准还原完整版内容。从欧洲艺术电影到亚洲独立制作，每一部都值得被完整看见。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Vintage%20film%20archive%20aesthetic%20wide%20banner%2C%20old%20film%20reels%20and%20dusty%20film%20cans%2C%20warm%20amber%20lighting%20in%20darkness%2C%20cinematic%20wide%20composition%2C%20nostalgic%20movie%20history%20atmosphere%2C%20rich%20textures%20with%20deep%20shadows&width=960&height=540&seq=car-2026-archive&orientation=landscape',
  },
  {
    id: 'car-3',
    title: '导演剪辑版：创作者的真实意图',
    subtitle: '对比解析 · 深度观影',
    desc: '导演剪辑版往往才是电影创作者想要呈现的完整故事。本专题聚焦知名导演作品中被删减的限制级片段与隐藏镜头，对比院线版与完整版的差异，解析删减背后的缘由。从叙事结构到视觉表达，还原每一帧被剪掉的真实。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Film%20director%20editing%20room%20atmosphere%20wide%20banner%2C%20vintage%20editing%20equipment%20in%20warm%20light%2C%20film%20strips%20hanging%2C%20dark%20cinematic%20workspace%2C%20gold%20and%20crimson%20color%20palette%2C%20wide%20composition%2C%20creative%20professional%20aesthetic&width=640&height=400&seq=car-2026-director&orientation=landscape',
  },
  {
    id: 'car-4',
    title: '海外完整版：跨区域观影指南',
    subtitle: '全球视野 · 版本对比',
    desc: '同一部电影在不同国家地区发行时，往往会因分级制度差异而产生不同版本。51电影网「海外完整版」专题系统整理了因地区差异而形成的多个版本，重点关注那些在海外保留了更多限制级镜头的完整版本，让你以全球视野看电影。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Global%20cinema%20concept%20wide%20banner%2C%20world%20map%20with%20film%20motifs%2C%20dark%20elegant%20aesthetic%2C%20multiple%20film%20frames%20from%20different%20regions%2C%20cinematic%20wide%20composition%2C%20deep%20blue%20and%20gold%20contrast%2C%20international%20film%20festival%20vibe&width=640&height=400&seq=car-2026-global&orientation=landscape',
  },
  {
    id: 'car-5',
    title: '高清修复计划：经典重获新生',
    subtitle: '蓝光品质 · 持续更新',
    desc: '许多经典的擦边电影因年代久远，现存版本画质堪忧，限制了观影体验。51电影网「高清修复计划」持续追踪并整理经过专业修复的蓝光级完整版资源，让那些被时间模糊的敏感镜头重新清晰呈现。目前已累计修复超过200部经典作品。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Film%20restoration%20studio%20wide%20banner%2C%20old%20film%20being%20digitally%20restored%2C%20contrast%20between%20vintage%20and%20modern%2C%20warm%20lighting%20on%20dark%20background%2C%20cinematic%20wide%20composition%2C%20professional%20color%20grading%20atmosphere%2C%20rich%20dark%20textures&width=640&height=400&seq=car-2026-restoration&orientation=landscape',
  },
];

export const mediaData = [
  {
    id: 'med-1',
    title: '《欲望迷宫》删减镜头深度解析',
    desc: '逐帧对比院线版与导演剪辑版中被隐藏的17分钟限制级片段',
    duration: '18:24',
    views: '5.2万',
    imageUrl: 'https://readdy.ai/api/search-image?query=Film%20analysis%20scene%20with%20side%20by%20side%20frame%20comparison%2C%20dark%20cinematic%20lighting%2C%20red%20accents%20on%20dark%20background%2C%20professional%20video%20essay%20aesthetic%2C%20film%20study%20composition%2C%20dramatic%20contrast%2C%20editorial%20style&width=640&height=360&seq=med-2026-1&orientation=landscape',
  },
  {
    id: 'med-2',
    title: '《暗夜追踪》海外版 vs 国内版',
    desc: '同一部电影两个版本的关键差异对比，敏感镜头逐一呈现',
    duration: '22:10',
    views: '4.8万',
    imageUrl: 'https://readdy.ai/api/search-image?query=Split%20screen%20film%20comparison%20with%20urban%20night%20action%20scene%2C%20dark%20cinematic%20aesthetic%2C%20neon%20accents%2C%20film%20analysis%20composition%2C%20professional%20video%20style%2C%20dramatic%20lighting%20contrast&width=640&height=360&seq=med-2026-2&orientation=landscape',
  },
  {
    id: 'med-3',
    title: '禁片简史：那些年被埋没的经典',
    desc: '盘点影史上被禁映或大量删减的十部经典限制级电影完整版',
    duration: '35:06',
    views: '3.5万',
    imageUrl: 'https://readdy.ai/api/search-image?query=Vintage%20banned%20films%20collection%20montage%2C%20old%20film%20posters%20in%20darkness%2C%20warm%20amber%20spotlight%2C%20cinematic%20history%20aesthetic%2C%20nostalgic%20film%20archive%20vibe%2C%20rich%20dark%20textures&width=640&height=360&seq=med-2026-3&orientation=landscape',
  },
  {
    id: 'med-4',
    title: '《禁忌游戏》隐藏结局全解析',
    desc: '蓝光修复版中被重新发现的隐藏结局，颠覆你对剧情的理解',
    duration: '14:52',
    views: '6.1万',
    imageUrl: 'https://readdy.ai/api/search-image?query=Mysterious%20film%20ending%20analysis%20with%20chess%20board%20and%20shadow%20play%2C%20dark%20elegant%20aesthetic%2C%20gold%20accents%2C%20cinematic%20composition%2C%20suspenseful%20atmosphere%2C%20film%20study%20style&width=640&height=360&seq=med-2026-4&orientation=landscape',
  },
  {
    id: 'med-5',
    title: '《深渊之眼》未分级版观影指南',
    desc: '首次公开的完整版观影指南，含敏感内容提醒与删减处标注',
    duration: '20:33',
    views: '4.0万',
    imageUrl: 'https://readdy.ai/api/search-image?query=Abstract%20eye%20motif%20with%20film%20frames%2C%20dark%20psychological%20thriller%20aesthetic%2C%20deep%20black%20and%20crimson%20contrast%2C%20cinematic%20composition%2C%20mysterious%20atmosphere%2C%20film%20analysis%20style&width=640&height=360&seq=med-2026-5&orientation=landscape',
  },
];

export const commentsData = [
  {
    id: 'cmt-1',
    name: '银幕旅人',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20dark%20user%20avatar%20with%20cinematic%20lighting%2C%20warm%20amber%20glow%20on%20dark%20background%2C%20abstract%20profile%2C%20simple%20elegant%20design&width=80&height=80&seq=avatar-cmt-01&orientation=squarish',
    date: '2026-07-28',
    content: '终于找到未删减版的完整合集了！之前看院线版总觉得情节有些跳跃，看了完整版才知道删了这么多关键镜头。尤其是《欲望迷宫》的隐藏结局，完全改变了整部电影的解读方向。感谢51电影网的整理！',
  },
  {
    id: 'cmt-2',
    name: '深夜放映室',
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20dark%20user%20avatar%20with%20film%20projector%20motif%2C%20warm%20gold%20light%2C%20dark%20background%2C%20minimalist%20cinematic%20design&width=80&height=80&seq=avatar-cmt-02&orientation=squarish',
    date: '2026-07-26',
    content: '每周都在等更新，已经成为我周末的固定仪式了。高清修复计划尤其赞，很多老电影之前只能看模糊的版本，现在蓝光级画质看限制级片段完全是另一种体验。禁片档案专题也特别有意思！',
  },
  {
    id: 'cmt-3',
    name: '光影捕手',
    avatar: 'https://readdy.ai/api/search-image?query=Dark%20minimalist%20user%20avatar%20with%20camera%20lens%20motif%2C%20crimson%20accent%2C%20dark%20background%2C%20simple%20elegant%20design%2C%20cinematic%20feel&width=80&height=80&seq=avatar-cmt-03&orientation=squarish',
    date: '2026-07-24',
    content: '海外完整版对比专题做得太用心了，同一部电影的不同版本放在一起对比，删减的地方一目了然。推荐给所有对电影完整叙事有追求的朋友，这里没有阉割版，只有导演真正想呈现的内容。',
  },
  {
    id: 'cmt-4',
    name: '午夜电影迷',
    avatar: 'https://readdy.ai/api/search-image?query=Dark%20minimalist%20user%20avatar%20with%20moon%20and%20film%20motif%2C%20gold%20accent%2C%20dark%20background%2C%20simple%20elegant%20design&width=80&height=80&seq=avatar-cmt-04&orientation=squarish',
    date: '2026-07-22',
    content: '冷门佳作专题是宝藏！挖掘了好几部之前完全没听说过的高分限制级电影，看完直呼过瘾。更新频率也很稳定，每周都能发现新东西，收藏夹已经快装不下了哈哈。',
  },
  {
    id: 'cmt-5',
    name: '胶片收藏家',
    avatar: 'https://readdy.ai/api/search-image?query=Dark%20minimalist%20user%20avatar%20with%20film%20strip%20motif%2C%20warm%20amber%20accent%2C%20dark%20background%2C%20simple%20elegant%20design&width=80&height=80&seq=avatar-cmt-05&orientation=squarish',
    date: '2026-07-20',
    content: '作为一个老影迷，51电影网对我来说简直是天堂。很多年轻时听说但从未看过的禁片和限制级经典，在这里都能找到完整的蓝光修复版。感谢团队的努力，让这些被时间尘封的镜头重见天日。',
  },
];

export const aboutData = {
  title: '关于51电影网',
  paragraphs: [
    '51电影网是一个专注于整理和分享擦边电影未删减版、限制级片段及隐藏敏感镜头的资源平台。我们相信每一部电影都值得被完整地观看——那些因审查、分级或市场考量而被删减的画面，往往承载着导演最真实的表达和影片最核心的力量。',
    '自成立以来，我们持续追踪全球范围内的未分级版本、海外完整版、导演剪辑版以及高清修复版资源，以每周更新的节奏为你呈现最全面的擦边电影完整版合集。从经典禁片档案到最新独家片源，从蓝光修复到版本对比解析，每一次更新都力求让你离电影的真实更近一步。',
    '我们坚持高清画质标准和严谨的资源筛选流程，确保站内每一部电影都能以最佳状态呈现。无论你是资深影迷还是刚刚开始探索未删减世界的观影者，51电影网都愿成为你发现电影完整之美的可靠伙伴。',
  ],
};

export const contactData = {
  title: '联系我们',
  intro: '如果你有未删减版资源线索、限制级片段投稿或任何合作建议，欢迎通过以下方式与我们取得联系。我们珍视每一位影迷的贡献与反馈。',
  email: 'contact@51movie.com',
  items: [
    { icon: 'ri-mail-line', label: '资源投稿', value: 'submit@51movie.com' },
    { icon: 'ri-chat-smile-2-line', label: '合作洽谈', value: 'contact@51movie.com' },
    { icon: 'ri-bug-line', label: '问题反馈', value: 'feedback@51movie.com' },
  ],
};

export const appData = {
  title: '随时随地 · 移动观影',
  subtitle: '51电影网移动端体验',
  desc: '将51电影网添加到手机主屏幕，随时随地浏览未删减版电影合集。支持离线收藏与观看提醒，不错过每一次稀缺资源更新。',
  features: ['高清流畅播放', '收藏与更新提醒', '深色模式适配', '每周新片推送'],
};